import * as React from "react";

export const useState: <T>(initialState: T) => [T, (state: T) => void] = (React as any).useState;
export const useEffect: (create: () => (() => void) | any, inputs?: any[]) => void = (React as any).useEffect;
export const useContext: <T>(context: React.Context<T>) => T = (React as any).useContext;
export const lazy: <T>(importStatement: () => Promise<T>) => any = (React as any).lazy;
export const Suspense: (props: { fallback: JSX.Element }) => JSX.Element = (React as any).Suspense;
